module.exports = __webpack_public_path__ + "img/cover3.752c5601.png";